import PropTypes from "prop-types";

const _Padding = PropTypes.shape({
  display_padding: PropTypes.bool,
  padding_top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

// Full Eyebrow prop types
export const _Eyebrow = PropTypes.shape({
  display_eyebrow_order: PropTypes.bool,
  display_eyebrow: PropTypes.bool,
  eyebrow_content: PropTypes.string,
  eyebrow_order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  eyebrow_padding: _Padding,
});

export const EyebrowPropTypes = _Eyebrow;
